import { Fragment, useState } from "react"
import PropTypes from "prop-types"

import { Dialog, Transition } from "@headlessui/react"

const InvoiceModal = ({
  message,
  open,
  setOpen,
  actionLabel,
  actionFunction,
  type,
}) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={open}
        onClose={() => setOpen(!open)}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          ></span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-2 pt-3 pb-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
              <div>
                <div className="text-center">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900 mb-6"
                  >
                    {message}
                  </Dialog.Title>
                  <button
                    onClick={() => {
                      setOpen(!open)
                      actionFunction()
                    }}
                    className={
                      type === "submit"
                        ? "bg-green-primary w-52 h-10 rounded-md mb-4 text-white"
                        : "bg-red-350 w-52 h-10 rounded-md mb-4 text-white"
                    }
                  >
                    {actionLabel}
                  </button>
                  <button
                    onClick={() => setOpen(!open)}
                    className={
                      type === "submit"
                        ? "bg-yellow-bg w-52 h-10 rounded-md mb-4"
                        : "bg-green-primary w-52 h-10 rounded-md mb-4 text-white"
                    }
                  >
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

InvoiceModal.propTypes = {
  message: PropTypes.any.isRequired,
  open: PropTypes.any.isRequired,
  setOpen: PropTypes.any.isRequired,
  actionLabel: PropTypes.any,
  actionFunction: PropTypes.any,
  type: PropTypes.any,
}

export default InvoiceModal
